module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }